<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="noindent"> </p>
<p class="halftitle"><a id="page_x"></a><a id="page_1"></a><strong><span class="small">The</span> Heart <span class="small">of</span> Redness</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?2ff7e1c7